import React from 'react';
import links from '../MenuLinks';
import InternalMenu from '../InternalMenu';

function FYHMenu() {
  const fyhLinks = links.find(linksCollection => linksCollection.menuName === 'Build Your Home');
  return (
    <InternalMenu
      links={fyhLinks.menuItems}
      menuName={fyhLinks.menuName}
    />
  );
}

export default FYHMenu;



// WEBPACK FOOTER //
// ./src/components/menus/FYH.js